import PanelOptionMixin from '../mixin';
import breakdownTranslatorMixin from '@/mixins/translator/breakdown';

import Dropdown from '@/components/Common/Dropdown';

import BreakdownIcon from '@svgIcons/dashboard/breakdown.svg';

import * as C from '../styles';
import * as S from './styles';

import { VERTICAL_SPACER } from '@/styles/common.styled.component';

import { makeBreakdownFormat } from '../../reactOptions/utils';

const COMMON_HEIGHT = {
    menuItemHeight: '32px',
};

export default {
    name: 'CreativeBreakdown',
    mixins: [PanelOptionMixin, breakdownTranslatorMixin],
    props: {
        creativeDimensionIds: {
            type: Array,
            default: [],
        },
        creativeAvailableDimensionList: {
            type: Array,
            default: [],
        },
    },
    computed: {
        dimensionId: R.compose(R.head, R.propOr([], 'creativeDimensionIds')),
    },
    methods: {
        renderContent() {
            const { dimensionId, creativeAvailableDimensionList = [] } = this;

            return (
                <S.Wrapper>
                    <div ref="dropdownWrapper">
                        <Dropdown
                            value={this.getBreakdownName(
                                makeBreakdownFormat(dimensionId)
                            )}
                            options={creativeAvailableDimensionList}
                            formatter={(key) =>
                                this.getBreakdownName(makeBreakdownFormat(key))
                            }
                            customStyles={COMMON_HEIGHT}
                            onInput={({ value }) => {
                                this.$emit('update', [value]);
                            }}
                            getPopupContainer={() => this.$refs.dropdownWrapper}
                        />
                    </div>
                    <VERTICAL_SPACER amount={12} />
                </S.Wrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderContent } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    children: renderContent(),
                    title: this.$t('NEW_DASHBOARD.graph_dropdown_breakdown'),
                    icon: <BreakdownIcon class="metric-icon" />,
                    hasEditBtn: false,
                })}
            </C.ComponentWrapper>
        );
    },
};
